/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ContestPlayerListDisplayQueryVariables = {|
  contestId: string
|};
export type ContestPlayerListDisplayQueryResponse = {|
  +playersForContest: ?$ReadOnlyArray<?{|
    +slatePlayer: ?{|
      +id: string,
      +salary: number,
      +player: {|
        +name: string
      |},
      +dkPoints: any,
      +dkLeaderboardPositionPoints: any,
      +isCut: boolean,
      +toPar: number,
      +prettyToPar: ?string,
    |},
    +percOwned: ?number,
  |}>
|};
export type ContestPlayerListDisplayQuery = {|
  variables: ContestPlayerListDisplayQueryVariables,
  response: ContestPlayerListDisplayQueryResponse,
|};
*/


/*
query ContestPlayerListDisplayQuery(
  $contestId: ID!
) {
  playersForContest(contestId: $contestId) {
    slatePlayer {
      id
      salary
      player {
        name
        id
      }
      dkPoints
      dkLeaderboardPositionPoints
      isCut
      toPar
      prettyToPar
    }
    percOwned
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contestId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "contestId",
    "variableName": "contestId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "salary",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dkPoints",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dkLeaderboardPositionPoints",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCut",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "toPar",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "prettyToPar",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "percOwned",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ContestPlayerListDisplayQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PGASweatsSlatePlayerOverviewType",
        "kind": "LinkedField",
        "name": "playersForContest",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SlatePlayerType",
            "kind": "LinkedField",
            "name": "slatePlayer",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PlayerType",
                "kind": "LinkedField",
                "name": "player",
                "plural": false,
                "selections": [
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/)
            ],
            "storageKey": null
          },
          (v10/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContestPlayerListDisplayQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PGASweatsSlatePlayerOverviewType",
        "kind": "LinkedField",
        "name": "playersForContest",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SlatePlayerType",
            "kind": "LinkedField",
            "name": "slatePlayer",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PlayerType",
                "kind": "LinkedField",
                "name": "player",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/)
            ],
            "storageKey": null
          },
          (v10/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "321e1dca1dd7ab346e4e4918b6de5cbe",
    "id": null,
    "metadata": {},
    "name": "ContestPlayerListDisplayQuery",
    "operationKind": "query",
    "text": "query ContestPlayerListDisplayQuery(\n  $contestId: ID!\n) {\n  playersForContest(contestId: $contestId) {\n    slatePlayer {\n      id\n      salary\n      player {\n        name\n        id\n      }\n      dkPoints\n      dkLeaderboardPositionPoints\n      isCut\n      toPar\n      prettyToPar\n    }\n    percOwned\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b50b49737522b88ecd5b47dc402e67e0';

module.exports = node;
